import {
  type UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';

import { fieldMappingsService } from '@/services/control/field-mappings-service';

import { adminMutationKeys, adminQueryKeys } from '@/hooks/admin/query-keys';

export function useDeleteFieldMapping(
  tenantId: string
): UseMutationResult<void, Error, string> {
  const queryClient = useQueryClient();

  return useMutation<void, Error, string>({
    mutationKey: adminMutationKeys.deleteFieldMapping(tenantId),
    mutationFn: (id) => fieldMappingsService.remove(tenantId, id),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: adminQueryKeys.fieldMappingsByTenant(tenantId),
      }),
  });
}
